import { Box } from '@mui/material';
import cameraMan from 'assets/images/cameraMan.png';
import girlWithHeadset from 'assets/images/girlWithHeadset.png';
import { ArticleImage, ImagesWrapper, Ring } from './styles';

const ImagesContainer = () => (
  <Box>
    <ArticleImage>
      <ImagesWrapper>
        <img src={cameraMan} alt="filme maker" className="image-bottom" />
        <Ring />
        <img
          src={girlWithHeadset}
          alt="girl listening music with headset"
          className="image-top"
        />
      </ImagesWrapper>
    </ArticleImage>
  </Box>
);

export default ImagesContainer;
